import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'How to Pack and Label Your Bags for Shipping | Ship&Play',
  description:
    'How to pack and label your luggage, boxes, and gear for shipping with Ship&Play ' +
    'for less than regular carriers charge.',
  alternates: {
    canonical: 'https://www.shipplay.com/pack',
  },
}

export default metadata
